/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function PartnerPackageAcceptRejectModalController(this: JS5Object, _: JS5Object) {
    this.approvalMessage = '';
    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };

    this.onDone = (): void => {
        this.close({$value: this.approvalMessage});
    };
}

angular
    .module('prism-ui.components')
    .component(
        'partnerPackageAcceptRejectModal',
        {
            controller: PartnerPackageAcceptRejectModalController,
            templateUrl: 'components/modal/partnerPackageAcceptReject/partner-package-accept-reject-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
